  import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker   } from 'antd';
import {  EditOutlined,SafetyCertificateOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			school_list: [],
			total_self: 0,
			total_franchise: 0,
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ 
			user_id : storedArray['data'][0]['user_id'],
		});
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var app = {user_id : user_id}
			getData('erp/master_school_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							total_school: result['total_school'],
							total_franchise: result['total_franchise'],
							total_self: result['total_self'],
						});
					}else{
						this.setState({
							school_list: [],
							total_school: 0,
						});
					}
				}
			});
	}
  }
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};

	render()

	{
	
	const { size } = this.state;
	
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<>
			    <div class="row bred">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i>My School
									<Link to={`${process.env.PUBLIC_URL}/my-school/my-school-add`} className="btn btn-outline-primary btn-rounded alignToTitle"><i class="mdi mdi-plus"></i> Add 
									</Link>
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> My School </li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>

                <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3">
					 <div class="card">
						<div class="card-body">
						<h4 class="mb-3 header-title">My School</h4>
                        <div class="table-responsive">
                           <table class="table table-striped table-bordered table-hover">
                              <thead>
                                 <tr>
                                    <th>#</th>
                                    <th>School Name</th>
									<th>Type</th>
									<th>Slot</th>
									<th>Address</th>
                                    <th>Action</th>
                                 </tr>
                              </thead>
                              <tbody>
							  {this.state.school_list.length == 0 && (<><tr><td colspan="5" class="text-center">No School Found</td></tr></>)}
							  {this.state.school_list.map((list,index) => (
                                 <tr>
									<td>{list.sr_no}</td>
                                    <td>{list.name}</td>
                                    <td>{list.type}</td>
                                    <td>{list.slot}</td>
                                    <td style={{'white-space':'break-spaces','word-break':'break-word'}}>{list.address}</td>
                                    
                                   

                                    <td>
										<div class="dropright dropright">
											<button type="button" class="btn btn-sm btn-outline-primary btn-rounded btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												<i class="mdi mdi-dots-vertical"></i>
											</button>
											<ul class="dropdown-menu">
												<li><Link to={`${process.env.PUBLIC_URL}/my-school/my-school-edit/${list.id}`} class="dropdown-item"><EditOutlined /> Edit</Link></li>
											</ul>
										</div>
                                    </td>
                                 </tr>
								 ))}
                                
                              </tbody>
                           </table>
                        </div>
                        </div>
                        </div>
                     </div>
                  </div>
               </div>
			   </>
		) 
	} 
}
export default Index;
